const mutations = {
  LOAD_LIST_EVENT_PARTICIPANTS(state, list) {
    state.listaEventParticipants = list;
  },
  PREPARE_TO_EDIT_EVENT_PARTICIPANT(state, data) {
    state.eventParticipant = { ...data };
  },
  RESET_EVENT_PARTICIPANT(state) {
    state.eventParticipant = {
      id: null,
      evento: { id: null },
      registro: { id: null },
      inscritoEm: new Date().toISOString(),
    };
  },
};

export default mutations;
